import { Mention } from '@syncfusion/ej2-dropdowns';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { RichTextEditor } from '@syncfusion/ej2-richtexteditor';

import { PlaceholderPopupProps } from '@/shared/types/components';
import { ClientType } from '@/shared/types/enum';
import { PLACEHOLDER_DELIMITERS, placeholdersForPrefixes } from '@/shared/utils/template';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.placeholder-popup')]
    .map((element) => element as HTMLElement)
    .forEach(function (element) {
      const { editableId, prefixes } = JSON.parse(element.dataset.props!) as PlaceholderPopupProps;

      const form = element.closest('form') as HTMLFormElement;

      const clientTypeEditable = form.querySelector('.editable[data-field="clientType"]') as HTMLDivElement | null;

      const clientTypeDropDownList = clientTypeEditable
        ? (getControl(clientTypeEditable.id) as DropDownList)
        : undefined;

      const editor = getControl(editableId!) as RichTextEditor;

      const target = editor.element.getElementsByClassName('e-content')[0] as HTMLElement;

      const mention = new Mention({
        dataSource: placeholdersForPrefixes(prefixes),
        fields: { text: 'name' },
        target,
        mentionChar: PLACEHOLDER_DELIMITERS[0][0],
        suggestionCount: 1000,
        popupWidth: '400px',
        popupHeight: '300px',
        highlight: true,
        noRecordsTemplate: 'No matching placeholders',
        displayTemplate: `${PLACEHOLDER_DELIMITERS[0]}\${name}${PLACEHOLDER_DELIMITERS[1]}`,
      });

      const refresh = () => {
        const clientType = (clientTypeDropDownList?.value ?? undefined) as ClientType | undefined;
        mention.dataSource = placeholdersForPrefixes(prefixes, clientType);
      };

      mention.appendTo(element);

      refresh();

      if (clientTypeEditable) {
        const clientTypeDropDownList = getControl(clientTypeEditable.id) as DropDownList;
        clientTypeDropDownList.addEventListener('change', refresh);
      }

      // Don't add line break when selecting placeholder by pressing enter
      editor.actionBegin = (args) => {
        if (args.requestType === 'EnterAction' && mention.element.classList.contains('e-popup-open')) {
          args.cancel = true;
        }
      };
    });
});
